export default __webpack_public_path__ + "static/media/camera-normal.44a7ec80.svg";